// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
process.env.API_VERSION = 'v1';
process.env.ADMIN_API_URL = `/api/${process.env.API_VERSION}`;

export const environment = {
    production: false,
    socket: {
        url: ':8085', options: {}
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts